var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundWave(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 559.67 426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff4ec;\n      }\n\n      .cls-2 {\n        fill: #e96851;\n        isolation: isolate;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.41,
    width: 559,
    height: 426
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "hjealthyish-sourdough",
    className: "cls-2",
    d: "M559.01,0H.41S-.52,104.96.41,232c150.76,43.96,327.66-118.72,559.09-.62.59-117.95-.49-231.38-.49-231.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundWave);
export default __webpack_public_path__ + "static/media/background-wave.643757a09adbdc7e1d4459645958f76e.svg";
export { ForwardRef as ReactComponent };